import {
    checkAccessToken,
    getAccessToken,
    refreshToken,
    registrationUser,
    forgotPasswordUser,
    resetPasswordUser,
    resetPasswordUserFromSettings,
    getCaptcha,
    resendVerifyEmailToUser,
} from '@requests/login';
import StorageToken from '@services/storage_token';
import {setConfig} from './config';
import {addNotification, loadingApplication} from './application';
import {
    SET_IS_LOGIN,
    SET_LOADED_LOGIN,
    SET_LOADING_LOGIN,
    SET_CAPTCHA_KEY,
    SET_CAPTCHA_IMG,
    SET_IS_SHOW_TWO_FACTOR,
    SET_VERIFY_EMAIL,
} from '../store/actionTypes';
import {handleError} from '../../middlewares/handleError';
import {setDigitalProfileCabinetLoaded} from './digital_profile_cabinet';

export function initializationLogin() {
    return async (dispatch) => {
        dispatch(loadingApplication(true));
        await dispatch(setConfig());
        const storageToken = new StorageToken();
        // проверяем access_token
        const accessToken = storageToken.getToken();
        const checkAccessTokenResult = accessToken ? await checkAccessToken(accessToken) : false;
        if (checkAccessTokenResult) {
            dispatch({
                type: SET_IS_LOGIN,
                payload: true,
            });
        } else {
            // проверяем refresh_token
            const isRefreshedAccessToken = await refreshToken();
            if (isRefreshedAccessToken) {
                dispatch({
                    type: SET_IS_LOGIN,
                    payload: true,
                });
            } else {
                const {hash} = document.location;
                if (!hash) {
                    window.location.hash = '/';
                }
            }
        }
        dispatch(loadingApplication(false));
        dispatch({
            type: SET_LOADED_LOGIN,
        });
    };
}

export const setIsLogin = (status) => {
    return (dispatch) => {
        dispatch({
            type: SET_IS_LOGIN,
            payload: status,
        });
    };
};

export const login = (login, password, code, t) => {
    return async (dispatch) => {
        try {
            if (login.length && password.length) {
                const accessTokenResponse = await getAccessToken(login, password, code, t);
                if (accessTokenResponse.access_token && accessTokenResponse.access_token !== '') {
                    const storageToken = new StorageToken();
                    storageToken.setToken(accessTokenResponse.access_token);
                    storageToken.setRefreshToken(accessTokenResponse.refresh_token);
                    dispatch({
                        type: SET_IS_LOGIN,
                        payload: true,
                    });
                } else if (accessTokenResponse.two_factor) {
                    dispatch({
                        type: SET_IS_SHOW_TWO_FACTOR,
                        payload: true,
                    });
                    dispatch(addNotification({
                        message: t('verification_code_sent'),
                        type: 'success',
                    }));
                } else if (accessTokenResponse.verify_required) {
                    dispatch({
                        type: SET_VERIFY_EMAIL,
                        payload: accessTokenResponse.email,
                    });
                    location.hash = 'registered';
                } else {
                    dispatch(addNotification({message: t('invalid_email_or_password'), type: 'error'}));
                }
            } else {
                dispatch(addNotification({message: t('empty_email_and_password'), type: 'error'}));
            }
        } catch (e) {
            dispatch(addNotification({message: e.message, type: 'error'}));
        }
    };
};

export function logout() {
    return (dispatch) => {
        const storageToken = new StorageToken();
        storageToken.removeToken();
        storageToken.removeRefreshToken();
        dispatch({
            type: SET_IS_LOGIN,
            payload: false,
        });
        dispatch({
            type: SET_IS_SHOW_TWO_FACTOR,
            payload: false,
        });
        dispatch(setDigitalProfileCabinetLoaded(false));
        location.hash = '';
    };
}

export const refreshCaptcha = () => {
    return async (dispatch, getState) => {
        try {
            const {apiDomainAuth} = getState();
            const captcha = await getCaptcha(apiDomainAuth);
            dispatch({
                type: SET_CAPTCHA_KEY,
                payload: captcha.key,
            });
            dispatch({
                type: SET_CAPTCHA_IMG,
                payload: captcha.img,
            });
        } catch (e) {
            dispatch(handleError(e));
        }
    };
};

export const registration = (data, t) => {
    return async (dispatch, getState) => {
        try {
            const {apiDomainAuth, captchaKey} = getState();
            const dataToSend = {
                ...data,
                key: captchaKey,
            };
            const isRegistered = await registrationUser(apiDomainAuth, dataToSend, t);
            dispatch({
                type: SET_VERIFY_EMAIL,
                payload: data.email,
            });
            if (isRegistered) {
                location.hash = 'registered';
            }
        } catch (e) {
            dispatch(refreshCaptcha());
            dispatch(handleError(e));
        }
    };
};

export const forgotPassword = (loginEmail, t) => {
    return async (dispatch, getState) => {
        try {
            const {apiDomainAuth} = getState();
            const isSendForgotPassword = await forgotPasswordUser(apiDomainAuth, loginEmail, t);
            if (isSendForgotPassword) {
                location.hash = 'send-link-reset-password';
            }
        } catch (e) {
            dispatch(handleError(e));
        }
    };
};

export const resetPassword = (data, t) => {
    return async (dispatch, getState) => {
        try {
            const {apiDomainAuth} = getState();
            const isResetPassword = await resetPasswordUser(apiDomainAuth, data, t);
            if (isResetPassword) {
                location.hash = 'reseted-password';
            }
        } catch (e) {
            dispatch(handleError(e));
        }
    };
};

export const resetPasswordFromSettings = (data, t) => {
    return async (dispatch, getState) => {
        try {
            const {apiDomainAuth} = getState();
            const isResetPassword = await resetPasswordUserFromSettings(apiDomainAuth, data, t);
            if (isResetPassword) {
                dispatch(addNotification({
                    message: t('password_changed_success'),
                    type: 'success',
                }));
            }
        } catch (e) {
            dispatch(handleError(e));
        }
    };
};

export const resendVerifyEmail = (t) => {
    return async (dispatch, getState) => {
        try {
            const {apiDomainAuth, verifyEmail} = getState();
            const isSendVerifyEmail = await resendVerifyEmailToUser(apiDomainAuth, verifyEmail, t);
            if (isSendVerifyEmail) {
                dispatch(addNotification({
                    message: t('link_send'),
                    type: 'success',
                }));
            }
        } catch (e) {
            dispatch(handleError(e));
        }
    };
};
